<img *ngIf="path && file_id"
     [src]="path + 'media/' + file_id + '/show'" height="32px" width="32px"
     style="border-radius: 50%; cursor: pointer"
     (click)="openDialog()"
/>
